import { initTippyTooltip } from "./module";

const tippySelector = '.js-tippy-tooltip';

$(init);
NLMK.initTippyTooltips = init;

function init() {
    $(tippySelector).each(initTippyTooltip);
}

export {};



// WEBPACK FOOTER //
// ./js/main/module/tippy/index.js